import { useEffect, useState } from "react";
import { Alert, Collapse, Paper, Typography } from "@mui/material";
import DealsAndPromotionsTabs from "./DealsAndPromotionsTabs";
import { Box, Grid } from "@mui/system";
import { useSelector } from "react-redux";
import { setDealsSuccessMessage } from "../../../features/dealsPromotionsSlice";
import store from "../../../store";

const DealsAndPromotions = () => {
  const successMessage = useSelector(
    (state: any) => state.dealsPromotions.successMessage,
  );
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (successMessage) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
        setTimeout(() => store.dispatch(setDealsSuccessMessage(null)), 300);
      }, 4500);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  return (
    <>
      <Paper sx={{ mb: 1 }}>
        <Box sx={{ padding: "10px 16px 0px" }}>
          <Grid container spacing={2} alignItems="center" sx={{ mb: 1 }}>
            <Grid size={12}>
              <Typography variant="h3" sx={{ fontSize: "24px" }}>
                Deals & Promotions
              </Typography>
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                Manage brand partnerships, promotions, and commissions in one
                place
              </Typography>
            </Grid>
          </Grid>

          <Collapse in={visible}>
            <Alert
              severity="success"
              onClose={() => {
                setVisible(false);
                setTimeout(
                  () => store.dispatch(setDealsSuccessMessage(null)),
                  300,
                );
              }}
              sx={{ mb: 1 }}
            >
              {successMessage}
            </Alert>
          </Collapse>
        </Box>

        <DealsAndPromotionsTabs />
      </Paper>
    </>
  );
};

export default DealsAndPromotions;
